var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertvector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189.001,
    height: 236.81,
    viewBox: "0 0 189.001 236.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2690",
    "data-name": "Rectangle 2690",
    width: 81.796,
    height: 81.797,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2692",
    "data-name": "Rectangle 2692",
    width: 34.015,
    height: 9.434,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alertvector",
    transform: "translate(-57.943 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10643",
    "data-name": "Group 10643",
    transform: "translate(57.943 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10640",
    "data-name": "Group 10640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10644",
    "data-name": "Group 10644",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10632",
    "data-name": "Group 10632",
    transform: "translate(102.012 60.61)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10631",
    "data-name": "Group 10631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10630",
    "data-name": "Group 10630",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12766",
    "data-name": "Path 12766",
    d: "M1243.581,486.68a41.166,41.166,0,0,1-3.137,6.7,40.9,40.9,0,0,1-76.091-17.884,40.215,40.215,0,0,1,.052-6.237,41.177,41.177,0,0,1,6.167-18.372c.017-.029.035-.054.052-.083a41,41,0,0,1,23.309-17.408c1-.286,2.011-.534,3.031-.743a40.666,40.666,0,0,1,22.161,1.635q1.466.533,2.864,1.165a40.609,40.609,0,0,1,16.573,13.683h0a41.044,41.044,0,0,1,6.54,14.838q.376,1.715.607,3.465a40.7,40.7,0,0,1-2.128,19.246",
    transform: "translate(-1164.257 -431.812)",
    fill: "#d7e5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12767",
    "data-name": "Path 12767",
    d: "M1237.026,455.887c-2.416,1.871-1.775,6.878-5.958,4.056s-6.808-4.356-7.992-1.894,2.521,3.811,1.545,6.495-2.96,2.967-5.052.763-2.154-4.325-5.543-4.255-4.836-1.324-4.67-3.868a3.58,3.58,0,0,0-.111-1.18c.017-.029.035-.055.052-.083a40.995,40.995,0,0,1,23.309-17.407c1-.286,2.011-.534,3.031-.743a5.378,5.378,0,0,1,3.121,3.409c1.475,4.3,3.868,3.287,1.836,6.889s-1.2,4.485,1.022,5.146,4.776,1.59,4.427,3.345-6.6-2.544-9.015-.673",
    transform: "translate(-1202.931 -436.934)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12768",
    "data-name": "Path 12768",
    d: "M1552.887,684.7a41.18,41.18,0,0,1-3.137,6.7,40.663,40.663,0,0,1-11.424,12.537,4.667,4.667,0,0,1-3.043-1.2c-4.1-3.659,1.332-7.545,4.19-9.436s-2.449-2.518-5.124-6.2,3.589-8.678-.437-8.948-8.922-.53-9.741-4.843,3.415-3.424,2.674-7.057,2.761-4.313,6.508-3.277,4.208-1.726,8.852-.471,2.458,6.97,7.581,8.4,4.481,2.5,4.481,2.5a2.47,2.47,0,0,1,.961.6,40.968,40.968,0,0,1-2.341,10.709",
    transform: "translate(-1473.563 -629.836)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12769",
    "data-name": "Path 12769",
    d: "M1616.23,567.282c-4.877.51-4.547-5.579-8.689-5.218-4.175.364-2.389-2.6-4.455-5.671s-9.038-1.4-7.622-4.507,5.308-.675,7.132-2.9,5.681-.105,5.681-.105a2.94,2.94,0,0,1,.8.1s0,0,0,0a41.039,41.039,0,0,1,6.539,14.838q.376,1.715.607,3.465",
    transform: "translate(-1534.777 -531.66)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12770",
    "data-name": "Path 12770",
    d: "M1466.507,472.868s3.312-2.345.2-4.524-3.49-.945-6.07-2.206-4.389.432-3.2,3.432,1.235,7.945,3.9,6.287,2.952-3.543,5.173-2.989",
    transform: "translate(-1415.963 -460.958)",
    fill: "#aec3ff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_12772",
    "data-name": "Path 12772",
    d: "M1696.892,1593.352h-13.246c-.71-.6.491-1.97,1.746-2.062a7.741,7.741,0,0,1,2.022.239c.182-2.421,1.223-13.3,5.146-12.867,4.411.49,0,4.793-1.247,7.341a60.562,60.562,0,0,0-2.343,5.87c.358.078.729.154,1.107.223.585-1.8,2.76-7.833,5.527-7.481,3.248.412,1.942,2.833-.36,4.27-1.689,1.057-3.763,2.559-4.749,3.284a14.062,14.062,0,0,0,2.591.208,5.582,5.582,0,0,1,3.806.975",
    transform: "translate(-1508.549 -1357.066)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12797",
    "data-name": "Path 12797",
    d: "M934.807,1050.611l-6.986,83.067s-.732,5.035,3.014,5.044c6.158.015,30.652,0,30.652,0s-4.635-1.048-4.579-3.406c.066-2.78,8.165-85.491,8.165-85.491Z",
    transform: "translate(-858.947 -902.469)",
    fill: "#7599ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12798",
    "data-name": "Path 12798",
    d: "M976.123,1128.018c-1.211,0-24.924.044-30.921-.033-2.614-.033-3.072-2.324-3.094-3.807a7.41,7.41,0,0,1,.079-1.237l.182-2.159.463-5.5.409-4.862.526-6.247.443-5.273,4.964-59.025,30.266-.785s-3.411,34.614-5.824,59.81c-.269,2.807-.526,5.5-.762,8.012q-.116,1.2-.222,2.35c-.224,2.384-.428,4.573-.606,6.506-.094,1.019-.18,1.965-.259,2.833-.308,3.4-.488,5.568-.491,5.98a3.5,3.5,0,0,0,.059.672c.5,2.647,4.335,2.767,4.789,2.767",
    transform: "translate(-871.277 -893.238)",
    fill: "#90aff4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12799",
    "data-name": "Path 12799",
    d: "M454.288,733.388,471.3,801.742l2.33,9.362,7.926,31.837H628.807L599.594,733.388Z",
    transform: "translate(-451.929 -630.448)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12800",
    "data-name": "Path 12800",
    d: "M439.842,733.387l-2.358.786,26.5,111.144,3.136-2.378Z",
    transform: "translate(-437.484 -630.447)",
    fill: "#90aff4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12801",
    "data-name": "Path 12801",
    d: "M626.252,1516.266h146.34l4.041-2.378H629.388Z",
    transform: "translate(-599.756 -1301.395)",
    fill: "#7599ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2691",
    "data-name": "Rectangle 2691",
    width: 31.685,
    height: 1.506,
    transform: "translate(77.886 234.78)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12802",
    "data-name": "Path 12802",
    d: "M977.233,1530.822l-.164,1.151-29.8,6.02.409-4.862.195-2.309Z",
    transform: "translate(-875.717 -1315.952)",
    fill: "#5888dd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10635",
    "data-name": "Group 10635",
    transform: "translate(70.831 225.36)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10634",
    "data-name": "Group 10634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10633",
    "data-name": "Group 10633",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12803",
    "data-name": "Path 12803",
    d: "M976.129,1614.975c-1.211,0-24.924.044-30.921-.033-2.614-.033-3.072-2.324-3.094-3.807l29.657-5.58c-.308,3.4-.488,5.568-.491,5.98a3.509,3.509,0,0,0,.059.672c.5,2.647,4.335,2.767,4.789,2.767",
    transform: "translate(-942.114 -1605.555)",
    fill: "#5888dd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_12804",
    "data-name": "Path 12804",
    d: "M454.286,733.387H599.593l23.576,88.046H476.205Z",
    transform: "translate(-451.928 -630.447)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12805",
    "data-name": "Path 12805",
    d: "M653.176,846.5H517.124l-4.862-19.367-1.881-7.494-.767-3.056-5-19.9-.259-1.036-2.641-10.521-1.182-4.707-1.008-4.016-2.363-9.413h134.09l2.6,9.413,1.106,4.016,1.3,4.707,8.549,31.012h0l.725,2.627.337,1.22,5.9,21.41Z",
    transform: "translate(-488.788 -659.333)",
    fill: "#739af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12806",
    "data-name": "Path 12806",
    d: "M633.854,776.4H499.532l-2.363-9.414h134.09Z",
    transform: "translate(-488.792 -659.331)",
    fill: "#607cf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12807",
    "data-name": "Path 12807",
    d: "M536.466,790.091a.889.889,0,0,1,.883-1.177,1.607,1.607,0,0,1,1.47,1.177.889.889,0,0,1-.883,1.177,1.608,1.608,0,0,1-1.47-1.177",
    transform: "translate(-522.542 -678.18)",
    fill: "#e9f3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12808",
    "data-name": "Path 12808",
    d: "M564.324,790.091a.889.889,0,0,1,.883-1.177,1.607,1.607,0,0,1,1.47,1.177.889.889,0,0,1-.883,1.177,1.607,1.607,0,0,1-1.47-1.177",
    transform: "translate(-546.49 -678.18)",
    fill: "#e9f3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12809",
    "data-name": "Path 12809",
    d: "M594.322,790.091a.889.889,0,0,1,.883-1.177,1.607,1.607,0,0,1,1.47,1.177.889.889,0,0,1-.883,1.177,1.608,1.608,0,0,1-1.47-1.177",
    transform: "translate(-572.276 -678.18)",
    fill: "#e9f3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12810",
    "data-name": "Path 12810",
    d: "M1213.736,52.926c5.5-6.456,13.979-19.426,19.688-26.067a2.106,2.106,0,0,0-1.6-3.477h-10.388l9.8-22.157a.869.869,0,0,0-1.49-.871l-23.693,31.711a1.311,1.311,0,0,0,1.211,2.086l11.761-1.448-7,19.221a1.009,1.009,0,0,0,1.715,1",
    transform: "translate(-1097.942 0.002)",
    fill: "#f77d48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12811",
    "data-name": "Path 12811",
    d: "M834.869,403.2c1.237-6.345,2.018-18.131,3.325-24.678a1.605,1.605,0,0,0-2.366-1.709l-6.9,3.886-1.78-18.382a.662.662,0,0,0-1.316-.021l-3.875,29.924a1,1,0,0,0,1.584.933l7.27-5.361,2.542,15.383a.769.769,0,0,0,1.514.024",
    transform: "translate(-767.985 -310.949)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12812",
    "data-name": "Path 12812",
    d: "M848.316,576.649,730.1,586.609a11.833,11.833,0,0,1-11.8-16.619L768.386,457.9a11.833,11.833,0,0,1,20.648-1.74L857.167,558.29a11.834,11.834,0,0,1-8.85,18.359",
    transform: "translate(-677.985 -387.605)",
    fill: "#e6efff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12813",
    "data-name": "Path 12813",
    d: "M821.187,553.625l-118.218,9.96A16.321,16.321,0,0,1,686.7,540.664l50.085-112.09a16.321,16.321,0,0,1,28.478-2.4L833.394,528.3a16.32,16.32,0,0,1-12.207,25.321m-70.12-125.713a7.253,7.253,0,0,0-6.09,4.323l-50.085,112.09a7.346,7.346,0,0,0,7.324,10.317l118.218-9.96a7.346,7.346,0,0,0,5.494-11.4L757.8,431.156a7.253,7.253,0,0,0-6.728-3.243",
    transform: "translate(-650.479 -360.109)",
    fill: "#f77d48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12814",
    "data-name": "Path 12814",
    d: "M1097.229,736.091a10.813,10.813,0,0,1,.46-4.293,9.911,9.911,0,0,1,2.023-3.553,10.622,10.622,0,0,1,3.4-2.518,13.245,13.245,0,0,1,4.651-1.194,13.55,13.55,0,0,1,4.821.4,10.56,10.56,0,0,1,3.805,1.911,9.919,9.919,0,0,1,2.589,3.165,10.835,10.835,0,0,1,1.172,4.156,10.58,10.58,0,0,1-.463,4.259,9.987,9.987,0,0,1-2.026,3.518,10.532,10.532,0,0,1-3.432,2.521,13.553,13.553,0,0,1-4.687,1.2,13.248,13.248,0,0,1-4.785-.4,10.591,10.591,0,0,1-3.77-1.914,9.972,9.972,0,0,1-2.586-3.13,10.556,10.556,0,0,1-1.169-4.121m18.277-21.386-17.028,1.435-7.314-57.98,21.853-1.841Z",
    transform: "translate(-999.411 -564.195)",
    fill: "#f77d48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12854",
    "data-name": "Path 12854",
    d: "M620.7,639.669a6.184,6.184,0,0,0,.889.967.653.653,0,0,0,.361.078l-.451-.812Z",
    transform: "translate(-594.981 -549.883)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12855",
    "data-name": "Path 12855",
    d: "M619.6,633.329l1.947.946a.347.347,0,0,1-.323.125,4.648,4.648,0,0,1-.845-.232Z",
    transform: "translate(-594.034 -544.433)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12859",
    "data-name": "Path 12859",
    d: "M1393.641,960.364a4.423,4.423,0,0,0-3.512.181c-5.976.245-6.2,6.371-5.5,8.65.985,3.2-2.5,5.726,1.365,7.021,4.486,1.5,8.25-.28,7.994.494,14.186,1.118,4.37-14.779-.35-16.346",
    transform: "translate(-1251.253 -825.337)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12860",
    "data-name": "Path 12860",
    d: "M1353.692,1096.46a15.686,15.686,0,0,1-1.6,2.416c-1.241,1.555-7.756-2.135-7.2-2.416s3.835-9.712,4.614-10.9,3.437-1.8,3.437-1.8Z",
    transform: "translate(-1217.503 -931.642)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12861",
    "data-name": "Path 12861",
    d: "M1524.5,1622.676s1.8,1.641,1.448,2.807-1.974,1.943-2.193,3.369-1.1,2.2-1.886,2.2H1518.1s-.581-1,.822-1.305,1.932-1.977,1.845-3.531a27.388,27.388,0,0,1,.131-3.628l2.983-.691Z",
    transform: "translate(-1366.319 -1394.245)",
    fill: "#1f447f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12862",
    "data-name": "Path 12862",
    d: "M1393.209,1632.4s.647,6.952-.143,7.341l-10.1-.021s0-1.166,1.623-1.425,4.474-1.209,4.956-3.325,3.667-2.57,3.667-2.57",
    transform: "translate(-1250.253 -1403.273)",
    fill: "#1c3154"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12863",
    "data-name": "Path 12863",
    d: "M1399.534,1088.4a40.254,40.254,0,0,1,0,4.67c-.1,1.688-1.808,3.95-2.05,4.509-.608,1.4-1.294,1.632-1.294,1.632l-5.3,1.3-1.865.457-5.882-1.757s-2.679-7.478-1.6-11.687a32.349,32.349,0,0,1,2.719-7.133,41.978,41.978,0,0,1,11.049-.4Z",
    transform: "translate(-1248.807 -928.274)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12864",
    "data-name": "Path 12864",
    d: "M1453,1146.5c-.1,1.688-2.313,3.891-2.555,4.45-.608,1.4-1.294,1.631-1.294,1.631l-5.3,1.3-.958-2.745s7.751-2.036,6.5-9.21Z",
    transform: "translate(-1301.767 -981.646)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12865",
    "data-name": "Path 12865",
    d: "M1378.171,1225.927s-2.913,9.067-3.1,12.154,5.568,43.852,5.8,45.274c.218,1.341,1.883,2.2,1.883,2.2a2.52,2.52,0,0,0,1.859.143,4.594,4.594,0,0,0,2-.941s2.267-29.073.864-39.459a164.5,164.5,0,0,1-1.42-19.367Z",
    transform: "translate(-1243.465 -1053.853)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12866",
    "data-name": "Path 12866",
    d: "M1415.4,1224s4.443,5.962,4.857,9.992.65,18.186,1.532,22.115,4.125,11.49,4.125,23.743a2.443,2.443,0,0,1-1.377,1.076,11.316,11.316,0,0,1-1.212.335,1.9,1.9,0,0,1-2.13-1.011c-2.192-4.414-9.175-18.648-9.533-21.6-.253-2.091-2.458-15.931-7.267-24.052-1.155-1.95.709-9.7.709-9.7Z",
    transform: "translate(-1268.351 -1052.198)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12867",
    "data-name": "Path 12867",
    d: "M1392.857,1215.956a6.1,6.1,0,0,0,3.492.972c2.774.056,9.65-.708,9.65-.708a5.686,5.686,0,0,1,.293,1.755s-8.4,2.118-13.263.309a3.075,3.075,0,0,1-.172-2.328",
    transform: "translate(-1258.616 -1045.281)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12868",
    "data-name": "Path 12868",
    d: "M1406.252,1222.362a1.444,1.444,0,1,1,1.266-1.433,1.359,1.359,0,0,1-1.266,1.433m0-2.446a1.03,1.03,0,1,0,.846,1.013.942.942,0,0,0-.846-1.013",
    transform: "translate(-1269.185 -1048.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12869",
    "data-name": "Path 12869",
    d: "M1341.893,1169.1l-12.621.118-6.211-14.6,12.622-.118Z",
    transform: "translate(-1198.759 -992.453)",
    fill: "#b5453c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12870",
    "data-name": "Path 12870",
    d: "M1405.814,1197.348l-.925-1.137a3.254,3.254,0,0,0-1.08-.653c-.454-.1-1.414-.648-1.507-.493s.737,1.268.737,1.268l.042.006c-.953.717-3.359.084-3.656.376-.36.354.5,1.12.954,1.551a3.368,3.368,0,0,0,2.794.829c.748-.233,1.925-.47,1.925-.47Z",
    transform: "translate(-1264.331 -1027.299)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12871",
    "data-name": "Path 12871",
    d: "M1329.328,1170.043s.793-.9,1.3-.469-.132,2.56-.613,2.344-.961-1.61-.685-1.875",
    transform: "translate(-1204.077 -1005.309)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12872",
    "data-name": "Path 12872",
    d: "M1441.943,1080.923s3.613.4,6.206,5.109c2.045,3.715,5.54,10.564,4.221,12.5-.579.849-6.129,3.871-16.835,2.144a3.238,3.238,0,0,1,1.032-1.979s9.01-2.893,8.994-3.468c-.029-1.088-1.217-2.029-6.25-7.063-1.368-1.369,2.632-7.242,2.632-7.242",
    transform: "translate(-1295.446 -929.202)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12873",
    "data-name": "Path 12873",
    d: "M1427.958,1048.45c.124-.167-.036-.7-.234-1.686a18.461,18.461,0,0,1-.478-3.839l-.267.045-4.478.753s.1,1.2.1,2.325c0,.009,0,.019,0,.028.005.979-.264,2.46.066,2.653,1.7.994,4.808.36,5.286-.281",
    transform: "translate(-1284.242 -896.538)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12874",
    "data-name": "Path 12874",
    d: "M1422.5,1044s.089,1.688.092,2.816c2.506-.06,3.843-2.493,4.386-3.57Z",
    transform: "translate(-1284.242 -896.811)",
    fill: "#e8945b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12875",
    "data-name": "Path 12875",
    d: "M1401.75,999.546s5.87-.836,5.293-4.484-.208-6.212-3.98-5.833-4.279,1.886-4.382,3.151,1.528,7.289,3.069,7.166",
    transform: "translate(-1263.76 -850.346)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12876",
    "data-name": "Path 12876",
    d: "M1410.831,985.653s2.285,4.023,4.846,4.264,3.523-.589,3.523-.589a7.056,7.056,0,0,1-2.934-3.753s-4.55-2.152-5.435.077",
    transform: "translate(-1274.21 -846.435)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12877",
    "data-name": "Path 12877",
    d: "M1397.673,990.536a3.678,3.678,0,0,0-1.469,1.579,5.968,5.968,0,0,0-.258,3.474s-1.671-2.716-.576-4.577c1.161-1.974,2.3-.476,2.3-.476",
    transform: "translate(-1260.599 -851.033)",
    fill: "#163560"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertvector);
export default __webpack_public_path__ + "static/media/alertvector.f4881f33a5c386246b4777873472798f.svg";
export { ForwardRef as ReactComponent };